/**
 * Setup-token fragment contract — frontend mirror of CLI custody URL (H10).
 *
 * Format: `/setup#token=<percent-encoded-token>`
 * Must stay in sync with `src/admin/owner-bootstrap/setup-url.ts`.
 * Contract tests live in `src/admin/owner-bootstrap/setup-url.contract.test.ts`.
 */

export function readSetupTokenFromFragment(
  hash: string = typeof window !== "undefined" ? window.location.hash : ""
): string | null {
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  if (!raw) return null;
  const params = new URLSearchParams(raw);
  const token = params.get("token")?.trim();
  return token || null;
}

/** Path-only redacted hint (never includes a raw token). */
export function setupPathHint(): string {
  return "/setup#token=<redacted>";
}
